//Angular
import {Component, Inject, OnInit, ViewEncapsulation} from "@angular/core";
import {MatDialogRef, MAT_DIALOG_DATA} from "@angular/material";
import {AbstractControl, FormControl, FormGroup, ValidationErrors, ValidatorFn, Validators} from "@angular/forms";
import { InventoryService } from "../../../../service/club-gigot/inventory.service";
import { CategoryProductDTO } from "../../../../model/club-gigot/inventory-points/product-category/category-product.dto";
import { BehaviorSubject, Subject } from "rxjs";
import { InventoryProductDTO } from "../../../../model/club-gigot/inventory-points/product/inventory-product.dto";
import { HttpErrorResponse } from "@angular/common/http";
import {Router} from "@angular/router";
import {Product, ProductsService} from "../../../../core/e-commerce";
import {AbortController} from "@microsoft/signalr/dist/esm/AbortController";

//Models

//Services

@Component({
  selector: 'cg-dialog-inventory-product',
  templateUrl: './dialog-inventory-product.component.html',
  styleUrls: ['./dialog-inventory-product.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class DialogInventoryProductComponent implements OnInit {

    public optionWasSelected : boolean = false;
    public _isEditMode : boolean = false;

    public newOtherProduct : FormGroup;

    /* Variable para el preview de la imagen
        de un nuevo producto "No Gigot" */
    public imageURLPreview : string;

    public error$ : BehaviorSubject<string> = new BehaviorSubject<string>('')

    public categories$ = new Subject<CategoryProductDTO[]>();

    public gigotProducts: Product[] = []

    public loading$: BehaviorSubject<boolean> = new BehaviorSubject(false)

    constructor(private dialogRef: MatDialogRef<DialogInventoryProductComponent>,
                private inventoryService : InventoryService,
                private productsService: ProductsService,
                private router: Router,
        @Inject(MAT_DIALOG_DATA)
        public data: DialogData,
             ) { }

    public ngOnInit() : void {
        this._isEditMode = this.data.product ? true : false;
        if(this._isEditMode){
            this.imageURLPreview = this.data.product.imageURL
            this.buildAddNewProduct();
        }
        this.loading$.next(true)
        this.productsService.getAllProducts().subscribe({
            next: (products: Product[]) =>{
                this.gigotProducts = products;
                this.loading$.next(false)
            }
        })
    }

    public onNoClick(): void {
        this.dialogRef.close(true);
    }

    public addGigotProducts() : void {
        this.dialogRef.close(false);
        this.router.navigate(['/action-points/stock/products/add'], {
        })

    }

    public buildAddNewProduct() : void {
        this.newOtherProduct = new FormGroup({
            id : new FormControl(this._isEditMode ? this.data.product.id : null),
            name: new FormControl(this._isEditMode ? this.data.product.name : null, [Validators.required]),
            stock: new FormControl(this._isEditMode ? this.data.product.stock : null, [Validators.required]),
            description: new FormControl(this._isEditMode ? this.data.product.description : null),
            image: new FormControl(null), // Solo se setea cuando se agrega una nueva imagen, en el back si es null no hace nada.
            height: new FormControl(this._isEditMode? this.data.product.height: null),
            width: new FormControl(this._isEditMode? this.data.product.width: null),
            length: new FormControl(this._isEditMode? this.data.product.length: null),
            inPiqueo: new FormControl(this._isEditMode? !this.data.product.inPiqueo: false, [Validators.required]),
            voucher: new FormControl(this._isEditMode? this.data.product.voucher: false, [Validators.required]),
            isGigotProduct: new FormControl(this._isEditMode? this.data.product.isGigotProduct:false),
            code: new FormControl(this._isEditMode? this.data.product.code: "")
        })
        this.newOtherProduct.controls['code'].setValidators([Validators.required, this.validateCode()])
        if((this._isEditMode && !this.data.product.isGigotProduct) || !this._isEditMode){
            this.newOtherProduct.controls['height'].setValidators([Validators.required, Validators.min(0)])
            this.newOtherProduct.controls['width'].setValidators([Validators.required, Validators.min(0)])
            this.newOtherProduct.controls['length'].setValidators([Validators.required, Validators.min(0)])
        }
        if(this._isEditMode && this.data.product.isGigotProduct){
            this.newOtherProduct.controls['code'].disable()
            this.newOtherProduct.controls['name'].disable()
        }
        this.optionWasSelected = true;
    }

    public uploadImage(event) : void {
        const file = (event.target as HTMLInputElement).files[0] as File;
        this.newOtherProduct.get("image").setValue(file);
        const reader = new FileReader();
        reader.onload = () => {
            this.imageURLPreview = reader.result as string;
        }
        reader.readAsDataURL(file)
        console.log(this.newOtherProduct.value)
    }

    public onSaveProduct() : void {
        this.newOtherProduct.controls['code'].enable()
        this.newOtherProduct.controls['name'].enable()
        this.newOtherProduct.controls["inPiqueo"].setValue(!this.newOtherProduct.controls["inPiqueo"].value)
        this.inventoryService.saveProduct(this.newOtherProduct.value)
            .subscribe({
                next : (_) => this.dialogRef.close(true),
                error: (errorResponse : HttpErrorResponse) => this.error$.next(errorResponse.error.errorMessage)
            })
    }

    /**
     * @description
     *	Valida que el codigo selecionado para el producto no exista entre los productos
     *  de Gigot ni entre los productos del Inventario
     */
    private validateCode(): ValidatorFn {
        return (control: AbstractControl): ValidationErrors | null => {
            if (!this._isEditMode){
                if (this.data.existingProducts.find(p => p.code == control.value)!= undefined)
                    return {existingCode: true}
                if (this.gigotProducts.find(p => p.code == control.value) != undefined)
                    return {existingCode: true}
            }else{
                if (this.data.existingProducts.find(p => p.code == control.value && p.id != this.data.product.id)!= undefined)
                    return {existingCode: true}
                if (this.gigotProducts.find(p => p.code == control.value ) != undefined)
                    return {existingCode: true}
            }
            return null
        };
    }
}

export interface DialogData {
    product?: InventoryProductDTO;
    existingProducts: InventoryProductDTO[]
}
